import { IconType, SvgIcon } from './SvgIcon';

export const ConnectisSmallLogo: IconType = ({ ...props }) => {
  return (
    <SvgIcon {...props} viewBox="0 0 34 22">
      <mask id="mask0_3229_9510" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="22">
        <path d="M0 0L21.1385 0V22H0L0 0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3229_9510)">
        <path
          d="M15.862 18.255C17.2249 17.3171 18.1811 15.9835 18.7296 14.2553L21.1385 14.8247C20.4835 17.0368 19.2473 18.7857 17.431 20.0713C15.6137 21.3569 13.4796 22 11.0293 22C7.94423 22 5.33458 20.9359 3.20127 18.8081C1.06708 16.6795 0 14.0762 0 10.9991C0 7.92299 1.06708 5.32047 3.20127 3.19272C5.33458 1.06409 7.94423 0 11.0293 0C13.4584 0 15.5873 0.637302 17.4151 1.91237C19.242 3.18656 20.4843 4.88798 21.1385 7.01661L18.7296 7.71209C18.2022 6.02605 17.2514 4.70881 15.8779 3.76128C14.5044 2.81289 12.8879 2.33858 11.0293 2.33858C8.64153 2.33858 6.62885 3.17173 4.99123 4.83581C3.35361 6.50078 2.53567 8.55526 2.53567 10.9991C2.53567 13.4228 3.35361 15.4724 4.99123 17.147C6.62885 18.8225 8.64153 19.6614 11.0293 19.6614C12.8888 19.6614 14.4991 19.192 15.862 18.255Z"
          fill="#2540F5"
        />
      </g>
      <path
        d="M33.0843 21.1788H20.6669C20.424 21.1788 20.191 21.0753 20.0192 20.8921C19.8475 20.7089 19.751 20.4604 19.751 20.2013C19.751 19.9422 19.8475 19.6937 20.0192 19.5105C20.191 19.3273 20.424 19.2246 20.6669 19.2246H33.0843C33.3272 19.2246 33.5602 19.3273 33.732 19.5105C33.9037 19.6937 34.0002 19.9422 34.0002 20.2013C34.0002 20.4604 33.9037 20.7089 33.732 20.8921C33.5602 21.0753 33.3272 21.1788 33.0843 21.1788Z"
        fill="#00FF8B"
      />
    </SvgIcon>
  );
};
